import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
// import Header from "./components/Header/Header";
import ProductList from "./pages/ProductList/ProductList";
// import Register from "./pages/Register/Register";
// import Login from "./pages/Login/Login";
import "./App.css";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // theme
import "primeflex/primeflex.css"; // css utility
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import AuthGuard from "./auth/AuthGuard";
import HomePage from "./pages/HomePage/HomePage";
// import Footer from "./components/Footer/Footer";
// import Cart from "./pages/Cart/Cart";
import Summary from "./pages/Summery/Summary";
// import MyProfile from "./pages/MyProfile/MyProfile";
import PageNotFound from "./pages/PageNotFount/PageNotFound";
import ServicesAndRepairs from "./pages/ServicesAndRepairs/ServicesAndRepairs";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Batteries from "./pages/Batteries/Batteries";
import ServicePackages from "./components/ServicePackages/ServicePackages";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import ProductDetails from "./components/ProductDetails/ProductDetails";
import StoreLocator from "./components/StoreLocator/StoreLocator";
import ContactUs from "./pages/ContactUs/ContactUs";
import ShippingAndDelivery from "./pages/ShippingAndDelivery/ShippingAndDelivery";
import RefundPolicy from "./components/refundPolicy/refundPolicy";
import HomePages from "./components/New-UserInterface/HomePage";
import Header from "./components/New-UserInterface/Header/Header";
import Footer from "./components/New-UserInterface/Footer/Footer";
import PassengerCarTyres from "./components/New-UserInterface/PassengerCarTyres/PassengerCarTyres";
import ProductDetailPage from "./components/New-UserInterface/ProductDetailPage/ProductDetailPage";
import Battery_product from "./components/New-UserInterface/Battery/Battery_product";
import SelectVehiclePage from "./components/New-UserInterface/ServicePackages/SelectVehicle/SelectVehiclePage";
// import ServicePackagesPage from "./components/New-UserInterface/ServicePackages/ServicePackages/ServicePackagesPage";
import AddVehicleCard from "./components/New-UserInterface/ServicePackages/AddVehicleCard/AddVehicleCard";
import ServiceBooking from "./components/New-UserInterface/ServiceRepair/ServiceBooking/ServiceBooking";
// import Login from "./components/New-UserInterface/LoginPage/Login/Login";
import Register from "./components/New-UserInterface/LoginPage/Register/Register";
import MyProfile from "./components/New-UserInterface/LoginPage/MyProfile/MyProfile";
import Cart from "./components/New-UserInterface/Cart/Cart";
import PunctureKit from "./components/New-UserInterface/PunctureProductCard/PunctureKit";
import MobilePolicyView from "./pages/MobilePolicyView/MobilePolicyView";
const App = () => {
  const basePath = process.env.REACT_APP_BASE_PATH || "";
  const location = useLocation();

  // const { user, login, logout } = useAuth();
  // const isAuthenticated = Boolean(user);
  // console.log("Base Path:", basePath); // Log the base path for debugging
  const isAuthenticated = true;

  const isMobilePolicyView  =
    [
      "privacy-policy",
      "shipping-policy",
      "termsandcondition",
      "terms-and-condition",
      "termsandconditions",
      "refund-policy",
      "policies",
      "app-policy",
      "app-policies",
      "mobile-policy",
    ].some((route) => location.pathname.toLowerCase().includes(route)) ||
    new URLSearchParams(location.search).get("webview") === "true" ||
    new URLSearchParams(location.search).get("hideHeaderFooter") === "true" ||
    new URLSearchParams(location.search).get("isApp") === "true";
  return (
    <div>
      {!isMobilePolicyView && <Header />}
      <div>
        <Routes>
          <Route path={`${basePath}`} element={<HomePages />} />
          <Route path={`${basePath}products`} element={<PassengerCarTyres />} />
          <Route
            path={`${basePath}productdetails/:id`}
            element={<ProductDetailPage />}
          />
          <Route path={`${basePath}batteries`} element={<Battery_product />} />
          <Route
            path={`${basePath}register`}
            element={<Register accountType="customer" />}
          />
          <Route path={`${basePath}privacy`} element={<PrivacyPolicy />} />
          <Route
            path={`${basePath}refund-return-policy`}
            element={<RefundPolicy />}
          />
          <Route path={`${basePath}puncture`} element={<PunctureKit />} />
          <Route
            path={`${basePath}privacy-customer`}
            element={<PrivacyPolicy />}
          />
          <Route path={`${basePath}terms`} element={<TermsAndConditions />} />
          <Route
            path={`${basePath}shipping-and-delivery-policy`}
            element={<ShippingAndDelivery />}
          />
          <Route
            path={`${basePath}terms-customer`}
            element={<TermsAndConditions />}
          />
          <Route
            path={`${basePath}findservicepoints`}
            element={<StoreLocator />}
          />
          <Route path={`${basePath}contact-us`} element={<ContactUs />} />
          <Route
            path={`${basePath}servicesandrepair`}
            element={<ServiceBooking />}
          />
          <Route
            path={`${basePath}servicepackages`}
            element={<ServicePackages />}
          />
          <Route path={`${basePath}cart`} element={<Cart />} />
          <Route
            path={`${basePath}summary`}
            element={
              <AuthGuard
                component={Summary}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route path={`${basePath}profile`} element={<MyProfile />} />
          {/* Dedicated Mobile App WebView Policy Routes (No Header & No Footer) */}
          <Route path={`${basePath}app-policy`} element={<MobilePolicyView />} />
          <Route path={`${basePath}app-policy/:policyType`} element={<MobilePolicyView />} />
          <Route path={`${basePath}app-policies`} element={<MobilePolicyView />} />
          <Route path={`${basePath}mobile-policy`} element={<MobilePolicyView />} />
          <Route path={`${basePath}mobile-policy/:policyType`} element={<MobilePolicyView />} />

          <Route path={`${basePath}*`} element={<PageNotFound />} />
        </Routes>
        {/* <AuthRedirect isAuthenticated={isAuthenticated} /> */}

        {/* <Route path={`${basePath}*`} element={<PageNotFound />} /> */}
        {/* <Route path={`${basePath}`} element={<HomePage />} /> */}
        {/* <Route path={"*"} element={<ProductDetailPage />} /> */}
        {/* <Route path={`${basePath}batteries`} element={<Batteries />} /> */}
        {/* <Route path={`${basePath}register`} element={<Register />} /> */}
        {/* <Route path={`${basePath}products`} element={<ProductList />} /> */}
        {/* <Route path={`${basePath}login`} element={<Login />} /> */}
        {/* <Route path={`${basePath}login`} element={<Login />} /> */}
        {/* <Route path="/productdetails/:slug" element={<ProductDetails />} /> */}
        {/* <Route
            path={`${basePath}servicesandrepair`}
            element={<ServicePackages/>}
          /> */}
        {/* <Route
            path={`${basePath}servicesandrepair`}
            element={<ServicePackagesPage />}
          /> */}
        {/* <Route path={`${basePath}AddVehicle`} element={<AddVehicleCard />} /> */}

        {/* <Route
            path={`${basePath}cart`}
            element={
              <AuthGuard component={Cart} isAuthenticated={isAuthenticated} />
            }
          /> */}
        {/* <Route
            path={`${basePath}profile`}
            element={
              <MyProfile /> */}

        {
          //   <AuthGuard
          //     component={MyProfile}
          //     isAuthenticated={isAuthenticated}
          //   />
        }
        {/* /> */}
        {/* <Route
            path={`${basePath}profile`}
            element={
              <AuthGuard
                component={MyProfile}
                isAuthenticated={isAuthenticated}
              />
            }
          /> */}
      </div>
      {!isMobilePolicyView && <Footer />}
    </div>
  );
};

export default App;
